
const isUat = process.env.REACT_APP_ENV === "uat";


const uatConfig = {
  axonURl: process.env.REACT_APP_MODEM,
  axonTokenURL: process.env.REACT_APP_AXON,
  accountManagementUrlAuth: process.env.REACT_APP_AMBASESEC,
  add_account_send_Otp: process.env.REACT_APP_ACCOTP,
  addUpdatePaymentMethodUrl_QA: process.env.REACT_APP_ADDDELPAY,
  appointmentDetailsUrlForCTL: process.env.REACT_APP_SLOT,
  buryCableMsgUrl: process.env.REACT_APP_BRYCABLE,
  confirmAvailableSlot: process.env.REACT_APP_CNFSLOT,
  deletePaymentMethodUrl_QA: process.env.REACT_APP_ADDDELPAY,
  dispatchMsgToTech: process.env.REACT_APP_TECHMSG,
  enrollAutoPay: process.env.REACT_APP_ENRPAY,
  fetchPastAppointments: process.env.REACT_APP_APPOINTMENT,
  forgot_account_number: process.env.REACT_APP_ACCFIND,
  getNotificationWithBan: process.env.REACT_APP_NOTIFICATIONLIST,
  getServiceDetails_with_ban: process.env.REACT_APP_SERVICE,
  getAccountDetailsByBANNZIP: process.env.REACT_APP_ACCDET,
  invoiceDetails_QA_Url: process.env.REACT_APP_INVOICE,
  makePaymentMethodDefaultUrl: process.env.REACT_APP_PAYDEFAULT,
  managePlandetailsCTL: process.env.REACT_APP_SUBACM,
  markPaymentDefault: process.env.REACT_APP_PAYDEFAULT,
  msgToTech: process.env.REACT_APP_MESPAY,
  notificationStatusUrl: process.env.REACT_APP_NOTIFICATION,
  outageInformationUrl_URL: process.env.REACT_APP_OUTAGE,
  pauseService: process.env.REACT_APP_ORDERSUS,
  paymentTokenUrl: process.env.REACT_APP_TOKEN,
  paymentGenerateSignatureUrl: process.env.REACT_APP_GENERATESIGN,
  planDetails_QA_Url: process.env.REACT_APP_SUBSPLAN,  
  purlPaymentUrl: process.env.REACT_APP_PAYNOW,
  purlPaymentAuthIdUrl: process.env.REACT_APP_PaymentAuthID,
  remove_autopay: process.env.REACT_APP_REMOVEPAY,
  repairAppointmentURL: process.env.REACT_APP_REPAIR,
  rescheduleAppointmentUrl: process.env.REACT_APP_RESCHEDULE,
  reviseOrder: process.env.REACT_APP_REVISEORDER,
  submitRescheduledAppointmentUrl: process.env.REACT_APP_SUBMITRESCHEDULE,
  upComingAppointmentUrl: process.env.REACT_APP_APPOINTMENT,
  upComingAppointmentUrl_QA: process.env.REACT_APP_APPOINTMENT,
  update_autopay: process.env.REACT_APP_UPDATEAUTOPAY,
  updateAccount: process.env.REACT_APP_CUSTPROF,
  updateCommPreferenc: process.env.REACT_APP_CUSTPREF,
  updateCustomerId_Url: process.env.REACT_APP_CUSTID,  
  viewInvoicePDF_Url_QA: process.env.REACT_APP_VIEWPDF,  
  accountId_QA_Url: process.env.REACT_APP_UPCOMPAY,
  accountManagementUrl: process.env.REACT_APP_AMBASESEC,  
  accountManagementNonAuthUrl: process.env.REACT_APP_AMNONAUTH, 
  addAutoPaymentMethodUrl_QA: process.env.REACT_APP_ADDPAY,
  addonsProducts: process.env.REACT_APP_ADDONS,
  addressQualificationURL: process.env.REACT_APP_ADDRQUAL,
  aem_content: process.env.REACT_APP_CMS, 
  amsLookUpURL: process.env.REACT_APP_LOOKUP,
  brightspeedGetTokenAPI: process.env.REACT_APP_DIGITALID,
  cancelAppointmentUrl: process.env.REACT_APP_CANCELAPPOINTMENT,
  captchaTokenValidateURL: process.env.REACT_APP_CAPCHA,
  cardVerificationUrl: process.env.REACT_APP_PAYAUTH,
  case: process.env.REACT_APP_ACPCASE,
  changeOrder: process.env.REACT_APP_CHANGEORDER,
  checkEmail: process.env.REACT_APP_EMAILVALIDATE,
  createCart: process.env.REACT_APP_CREATECART,   
  createPin: process.env.REACT_APP_CREATE_PIN,
  decryptionQstr_Url: process.env.REACT_APP_UNENCY,
  dwLoggingUrl: process.env.REACT_APP_LOG,
  encryptionQstr_Url: process.env.REACT_APP_ENCY,
  forgotPassGenerateOTPUrl: process.env.REACT_APP_FORGOTPASS,
  forgotUserName_QA_URL: process.env.REACT_APP_FINDUSER,
  forgotUsernameUrl: process.env.REACT_APP_FINDUSERNAME,
  getAzureInfoUrl: process.env.REACT_APP_AZ,
  getV2InternetProduct: process.env.REACT_APP_INTERNET,
  getVoiceProductUrl: process.env.REACT_APP_VOICE,
  iAmTokenUrl: process.env.REACT_APP_AMTOKEN,
  listPaymentMethods_QA_Url: process.env.REACT_APP_LISTPAYMENTS,
  non_auth_paymentArrangements: process.env.REACT_APP_PAPLANS,
  nutritionlabel: process.env.REACT_APP_NUTRILABEL,
  passwordResetConfirmation: process.env.REACT_APP_RESETCNF,
  payment_arrangment_send_otp: process.env.REACT_APP_PAOTP,
  paymentArrangementUrl_QA: process.env.REACT_APP_PAPAY,  
  paymentHistoryUrl_QA_URL: process.env.REACT_APP_PAYHISTORY,
  invoiceHistoryUrl_QA_URL: process.env.REACT_APP_INVOICEHISTORY,
  paymentHistoryUrlForPA_QA: process.env.REACT_APP_PAHISTORY,
  paymetArrangemetUserValidateURL: process.env.REACT_APP_FINDUSER,
  paypalUrl: process.env.REACT_APP_PAYPAL,
  purlPaymentAuthId: process.env.REACT_APP_PURLPAYAUTH,
  moversPurlPaymentAuthID: process.env.REACT_APP_MOVERS_PURLPAYAUTH,
  addPaymentNA: process.env.REACT_APP_ADDPAY_NA,
  quickPayURL: process.env.REACT_APP_QBP, 
  qbpNonauthURL: process.env.REACT_APP_QBP_NA, 
  registered_user_notify: process.env.REACT_APP_USERNOTIFY,
  registerUserAIM_url: process.env.REACT_APP_USERREGISTER,
  resendOTPUrl: process.env.REACT_APP_RESENDOTP, 
  unifiedLoginWithEmailAddress_lookup_Url: process.env.REACT_APP_ACCLOOKUP,
  unifiedLoginWithMobileNumberTN_lookup_Url: process.env.REACT_APP_PHLOOKUP,  
  upcomingPayment_QA_Url: process.env.REACT_APP_UPCOMPAY,  
  updateCart: process.env.REACT_APP_UPDATECART,
  updatePaymentMethodUrl_QA: process.env.REACT_APP_UPDATEPAYMETHOD,
  updatePaymentMethodNA: process.env.REACT_APP_UPDATEPAYMETHOD_NA,
  userInfoByAccIdUrl: process.env.REACT_APP_ACCINFO,
  validate_user_name: process.env.REACT_APP_VALIDATEUSER,
  validateOTP_Url: process.env.REACT_APP_VALIDATEOTP,
  validatePortingTelephone: process.env.REACT_APP_TELPORTING,   
  voicePortingData: process.env.REACT_APP_PREVALIDATE, 
  fetchID: process.env.REACT_APP_FETCHID,
  getAzureInfoUrl: process.env.REACT_APP_FETCHID_GETAZ,
  non_auth_QBP_payment_details: process.env.REACT_APP_NON_QBP,
  paymentCardIdentification: process.env.REACT_APP_PAYMENT_IDENT,
  getCreditMemoUrl: process.env.REACT_APP_GET_CREDIT_MEMO,
  myRewardsUrl: process.env.REACT_APP_MY_REWARDS_URL,
  autopayNotifyUrl: process.env.REACT_APP_AUTOPAY_NOTIFY,
};

const defaultConfig = {
  accountManagementUrlAuth: process.env.REACT_APP_AMBASESEC,
  add_account_send_Otp: process.env.REACT_APP_ACCOTP,
  addUpdatePaymentMethodUrl_QA: process.env.REACT_APP_ADDDELPAY,
  appointmentDetailsUrlForCTL: process.env.REACT_APP_SLOT,
  axonURl: process.env.REACT_APP_MODEM,
  buryCableMsgUrl: process.env.REACT_APP_BRYCABLE,
  confirmAvailableSlot: process.env.REACT_APP_CNFSLOT,
  deletePaymentMethodUrl_QA: process.env.REACT_APP_ADDDELPAY,
  dispatchMsgToTech: process.env.REACT_APP_TECHMSG,
  enrollAutoPay: process.env.REACT_APP_ENRPAY,
  fetchPastAppointments: process.env.REACT_APP_APPOINTMENT,
  forgot_account_number: process.env.REACT_APP_ACCFIND,
  getNotificationWithBan: process.env.REACT_APP_NOTIFICATIONLIST,
  getServiceDetails_with_ban: process.env.REACT_APP_SERVICE,
  getAccountDetailsByBANNZIP: process.env.REACT_APP_ACCDET,
  invoiceDetails_QA_Url: process.env.REACT_APP_INVOICE,
  makePaymentMethodDefaultUrl: process.env.REACT_APP_PAYDEFAULT,
  managePlandetailsCTL: process.env.REACT_APP_SUBACM,
  markPaymentDefault: process.env.REACT_APP_PAYDEFAULT,
  msgToTech: process.env.REACT_APP_MESPAY,
  notificationStatusUrl: process.env.REACT_APP_NOTIFICATION,
  outageInformationUrl_URL: process.env.REACT_APP_OUTAGE,
  pauseService: process.env.REACT_APP_ORDERSUS,
  paymentTokenUrl: process.env.REACT_APP_TOKEN,
  paymentGenerateSignatureUrl: process.env.REACT_APP_GENERATESIGN,
  planDetails_QA_Url: process.env.REACT_APP_SUBSPLAN,  
  purlPaymentUrl: process.env.REACT_APP_PAYNOW,
  remove_autopay: process.env.REACT_APP_REMOVEPAY,
  repairAppointmentURL: process.env.REACT_APP_REPAIR,
  rescheduleAppointmentUrl: process.env.REACT_APP_RESCHEDULE,
  reviseOrder: process.env.REACT_APP_REVISEORDER,
  submitRescheduledAppointmentUrl: process.env.REACT_APP_SUBMITRESCHEDULE,
  upComingAppointmentUrl: process.env.REACT_APP_APPOINTMENT,
  upComingAppointmentUrl_QA: process.env.REACT_APP_APPOINTMENT,
  update_autopay: process.env.REACT_APP_UPDATEAUTOPAY,
  updateAccount: process.env.REACT_APP_CUSTPROF,
  updateCommPreferenc: process.env.REACT_APP_CUSTPREF,
  updateCustomerId_Url: process.env.REACT_APP_CUSTID,  
  viewInvoicePDF_Url_QA: process.env.REACT_APP_VIEWPDF,  
  accountId_QA_Url: process.env.REACT_APP_UPCOMPAY,
  accountManagementUrl: process.env.REACT_APP_AMBASESEC,  
  accountManagementNonAuthUrl: process.env.REACT_APP_AMNONAUTH, 
  addAutoPaymentMethodUrl_QA: process.env.REACT_APP_ADDPAY,
  addonsProducts: process.env.REACT_APP_ADDONS,
  addressQualificationURL: process.env.REACT_APP_ADDRQUAL,
  aem_content: process.env.REACT_APP_CMS, 
  amsLookUpURL: process.env.REACT_APP_LOOKUP,
  axonTokenURL: process.env.REACT_APP_AXON,
  brightspeedGetTokenAPI: process.env.REACT_APP_DIGITALID,
  cancelAppointmentUrl: process.env.REACT_APP_CANCELAPPOINTMENT,
  captchaTokenValidateURL: process.env.REACT_APP_CAPCHA,
  cardVerificationUrl: process.env.REACT_APP_PAYAUTH,
  case: process.env.REACT_APP_ACPCASE,
  changeOrder: process.env.REACT_APP_CHANGEORDER,
  checkEmail: process.env.REACT_APP_EMAILVALIDATE,
  createCart: process.env.REACT_APP_CREATECART,   
  createPin: process.env.REACT_APP_CREATE_PIN,
  decryptionQstr_Url: process.env.REACT_APP_UNENCY,
  dwLoggingUrl: process.env.REACT_APP_LOG,
  encryptionQstr_Url: process.env.REACT_APP_ENCY,
  forgotPassGenerateOTPUrl: process.env.REACT_APP_FORGOTPASS,
  forgotUserName_QA_URL: process.env.REACT_APP_FINDUSER,
  forgotUsernameUrl: process.env.REACT_APP_FINDUSERNAME,
  getAzureInfoUrl: process.env.REACT_APP_AZ,
  getV2InternetProduct: process.env.REACT_APP_INTERNET,
  getVoiceProductUrl: process.env.REACT_APP_VOICE,
  iAmTokenUrl: process.env.REACT_APP_AMTOKEN,
  listPaymentMethods_QA_Url: process.env.REACT_APP_LISTPAYMENTS,
  non_auth_paymentArrangements: process.env.REACT_APP_PAPLANS,
  nutritionlabel: process.env.REACT_APP_NUTRILABEL,
  passwordResetConfirmation: process.env.REACT_APP_RESETCNF,
  payment_arrangment_send_otp: process.env.REACT_APP_PAOTP,
  paymentArrangementUrl_QA: process.env.REACT_APP_PAPAY,  
  paymentHistoryUrl_QA_URL: process.env.REACT_APP_PAYHISTORY,
  invoiceHistoryUrl_QA_URL: process.env.REACT_APP_INVOICEHISTORY,
  paymentHistoryUrlForPA_QA: process.env.REACT_APP_PAHISTORY,
  paymetArrangemetUserValidateURL: process.env.REACT_APP_FINDUSER,
  paypalUrl: process.env.REACT_APP_PAYPAL,
  purlPaymentAuthId: process.env.REACT_APP_PURLPAYAUTH,
  moversPurlPaymentAuthID: process.env.REACT_APP_MOVERS_PURLPAYAUTH,
  addPaymentNA: process.env.REACT_APP_ADDPAY_NA,
  quickPayURL: process.env.REACT_APP_QBP, 
  qbpNonauthURL: process.env.REACT_APP_QBP_NA, 
  registered_user_notify: process.env.REACT_APP_USERNOTIFY,
  registerUserAIM_url: process.env.REACT_APP_USERREGISTER,
  resendOTPUrl: process.env.REACT_APP_RESENDOTP, 
  unifiedLoginWithEmailAddress_lookup_Url: process.env.REACT_APP_ACCLOOKUP,
  unifiedLoginWithMobileNumberTN_lookup_Url: process.env.REACT_APP_PHLOOKUP,  
  upcomingPayment_QA_Url: process.env.REACT_APP_UPCOMPAY,  
  updateCart: process.env.REACT_APP_UPDATECART,
  updatePaymentMethodUrl_QA: process.env.REACT_APP_UPDATEPAYMETHOD,
  updatePaymentMethodNA: process.env.REACT_APP_UPDATEPAYMETHOD_NA,
  userInfoByAccIdUrl: process.env.REACT_APP_ACCINFO,
  validate_user_name: process.env.REACT_APP_VALIDATEUSER,
  validateOTP_Url: process.env.REACT_APP_VALIDATEOTP,
  validatePortingTelephone: process.env.REACT_APP_TELPORTING,   
  voicePortingData: process.env.REACT_APP_PREVALIDATE, 
  fetchID: process.env.REACT_APP_FETCHID,
  getAzureInfoUrl: process.env.REACT_APP_FETCHID_GETAZ,
  non_auth_QBP_payment_details: process.env.REACT_APP_NON_QBP,
  paymentCardIdentification: process.env.REACT_APP_PAYMENT_IDENT,
  getCreditMemoUrl: process.env.REACT_APP_GET_CREDIT_MEMO,
  myRewardsUrl: process.env.REACT_APP_MY_REWARDS_URL,
  autopayNotifyUrl: process.env.REACT_APP_AUTOPAY_NOTIFY,
};





export default isUat ? uatConfig : defaultConfig;